import { render, staticRenderFns } from "./TabMemberPackage.vue?vue&type=template&id=27ddfdf8"
import script from "./TabMemberPackage.vue?vue&type=script&lang=js"
export * from "./TabMemberPackage.vue?vue&type=script&lang=js"
import style0 from "./TabMemberPackage.vue?vue&type=style&index=0&id=27ddfdf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports